import { endpoints, poster, posterForm } from '../utils/axios';

// export const loginMobile = async (phoneNumber) => {
//   try {
//     const response = await poster(`${endpoints.auth.login}`, { phoneNumber });
//     return response;
//   } catch (error) {
//     console.error('loginMobile error:', error);
//     var response = {};
//     response.status = false;
//     response.message = error?.response?.data?.message ?? error.message;
//     return response;;
//   }
// };

export const loginMobile = async (data) => {
  try {
    const response = await poster(`${endpoints.auth.login}`, data); 
    return response;
  } catch (error) {
    console.error('loginMobile error:', error);
    return {
      status: false,
      message: error?.response?.data?.message ?? error.message,
    };
  }
};

export const OtpVerify = async (args) => {
  try {
    const response = await poster(`${endpoints.auth.OtpVerify}`, args);
    return response;
  } catch (error) {
    console.error('OtpVerify error:', error);
    var response = {};
    response.status = false;
    response.message = error?.response?.data?.message ?? error.message;
    return response;;
  }
};

export const loginPassword = async (args) => {
  try {
    const response = await poster(`${endpoints.auth.LoginPassword}`, args);
    return response;
  } catch (error) {
    console.error('loginPassword error:', error);
    var response = {};
    response.status = false;
    response.message = error?.response?.data?.message ?? error.message;
    return response;;
  }
};

export const VerifyToken = async (args = {}) => {
  try {
    const response = await poster(`${endpoints.auth.VerifyToken}`, args);
    return response;
  } catch (error) {
    console.error('VerifyToken error:', error);
    var response = {};
    response.status = false;
    response.message = error?.response?.data?.message ?? error.message;
    return response;;
  }
};

export const useLogout = async (args = {}) => {
  try {
    const response = await poster(`${endpoints.auth.Logout}`, args);
    return response;
  } catch (error) {
    console.error('Logout error:', error);
    var response = {};
    response.status = false;
    response.message = error?.response?.data?.message ?? error.message;
    return response;;
  }
};

export const userOnboarding = async (args = {}) => {
  try {
    const response = await poster(`${endpoints.Onboarding.userOnboarding}`, args);
    return response;
  } catch (error) {
    console.error('userOnboarding error:', error);
    var response = {};
    response.status = false;
    response.message = error?.response?.data?.message ?? error.message;
    return response;;
  }
};

export const centerOnboarding = async (args = {}) => {
  try {
    const response = await posterForm(`${endpoints.Onboarding.userOnboarding}`, args);
    return response;
  } catch (error) {
    console.error('centerOnboarding error:', error);
    var response = {};
    response.status = false;
    response.message = error?.response?.data?.message ?? error.message;
    return response;;
  }
};

export const addMember = async (args = {}) => {
  try {
    const response = await poster(`${endpoints.Onboarding.addMember}`, args);
    return response;
  } catch (error) {
    console.error('addMember error:', error);
    var response = {};
    response.status = false;
    response.message = error?.response?.data?.message ?? error.message;
    return response;;
  }
};

export const memberOnboarding = async (args = {}) => {
  try {
    const response = await poster(`${endpoints.Onboarding.memberOnboarding}`, args);
    return response;
  } catch (error) {
    console.error('memberOnboarding error:', error);
    var response = {};
    response.status = false;
    response.message = error?.response?.data?.message ?? error.message;
    return response;;
  }
};

export const Registerfcmtoken = async (args = {}) => {
  try {
    const payload = { ...args, platform: "web" };
    const response = await poster(`${endpoints.auth.Registerfcmtoken}`, payload);
    return response;
  } catch (error) {
    console.error('fcmToken error:', error);
    var response = {};
    response.status = false;
    response.message = error?.response?.data?.message ?? error.message;
    return response;
  }
};

export const sendWhatsAppOtp = async (args = {}) => {
  try {
    const response = await poster(`${endpoints.auth.sendOtp}`, args);
    return response;
  } catch (error) {
    console.error('sendWhatsAppOtp error:', error);
    const response = {
  status: false,
  message: error?.response?.data?.message ?? error.message ?? 'Unknown error',
};
return response;
}
};